import * as React from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps, useParams } from 'react-router';
import _ from 'lodash';

import { Layout, Row, Col, Button, Tooltip } from 'antd';
import { LeftOutlined, HomeOutlined } from '@ant-design/icons';

import { RootState } from '../../../application/store';

import './bv-products-template.scss';

import bvLogo from '../../../assets/images/bv-logo.png';

import BVSidebarNav from '../../components/BVSidebarNav/bv-sidebar-nav';
import BVSignout from '../../components/BVSignout/bv-signout';
import BVBasketDrawer from '../../components/BVDrawers/BVBasketDrawer/bv-basket-drawer';
import BVCheckoutDrawer from '../../components/BVDrawers/BVCheckoutDrawer/bv-checkout-drawer';

const {
    Content,
    Header
} = Layout;

interface IRouteParams {
    businessUnitCode: string,
    productId: string
}

const BVProductsTemplate: React.FunctionComponent<RouteComponentProps> = (props) => {
    const {
        businessUnitCode,
        productId
    } = useParams<IRouteParams>();

    const bvCustomer = useSelector((state: RootState) => state.customer);

    return (
        <Layout className={'bv-products-template'}>
            <BVSidebarNav />

            <Layout>
                <Header className={'template-header'}>
                    <img src={bvLogo} alt={'Bulgari'} />

                    <BVSignout />
                </Header>

                <Layout>
                    <Content className="template-content">
                        <Row align={'middle'} gutter={[16, 0]}>
                            {_.includes(bvCustomer.posAssortment, 'J') && _.includes(bvCustomer.posAssortment, 'W') && businessUnitCode && !productId &&
                                <Col>
                                    <Tooltip title={'Back to catalog'}>
                                        <Button type="primary" shape="circle" icon={<HomeOutlined />} onClick={() => props.history.push('/catalog')} />
                                    </Tooltip>
                                </Col>
                            }

                            {productId &&
                                <Col>
                                    <Tooltip title={'Back'}>
                                        <Button type="primary" shape="circle" icon={<LeftOutlined />} onClick={() => props.history.goBack()} />
                                    </Tooltip>
                                </Col>
                            }

                            <Col>
                                <span className="template-heading">
                                    {bvCustomer.fullName || '-'}
                                </span>
                            </Col>
                        </Row>

                        {props.children}
                    </Content>

                    <BVBasketDrawer />

                    <BVCheckoutDrawer />
                </Layout>
            </Layout>
        </Layout >
    );
}

export default BVProductsTemplate;